
<!--    基础游课程服务-->
<template>
  <div>
    <div class="title-container" shadow="never" style="margin-top: 0px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="warning" size="medium" style="width: 120px;" class="operator-btn2" icon="el-icon-service" @click="handleAfterClassShowDlg()">服 务</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table
        :data="dataList"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        highlight-current-row
        @row-click="rowClick"
        max-height="490"
        border>
        <el-table-column prop="userPhone" label="卡号"></el-table-column>
        <el-table-column prop="childName" label="会员姓名" ></el-table-column>
        <el-table-column prop="singInTime" label="签到时间"></el-table-column>
        <el-table-column prop="childPetName" label="会员小名"></el-table-column>
        <el-table-column prop="serviceTeacherName" label="服务泳师"></el-table-column>
        <el-table-column prop="circle" label="泳圈"></el-table-column>
        <el-table-column prop="swTime" label="游泳时长(分)"></el-table-column>
        <el-table-column prop="height" label="身高/cm"></el-table-column>
        <el-table-column prop="weight" label="体重/kg"></el-table-column>
        <el-table-column prop="content" label="互动内容"></el-table-column>
        <el-table-column prop="point" label="满意度" ></el-table-column>
        <el-table-column prop="finish" label="完成" ></el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="课后服务"
      :visible.sync="visibleAfterClassService"
      width="50%"
      center>
      <after-class-service :key="afterClassServiceDetailrefresh" v-bind:service-items="serviceItems"  @onBtnOK="onBtnOKSerivce" v-bind:detail="selectRow"></after-class-service>
    </el-dialog>
    <el-dialog
      title="图片预览"
      :visible.sync="visibleVisitPic"
      width="50%"
      center>
      <visit-pics :key="refreVisitPic" :pics="visitPicList" ></visit-pics>
    </el-dialog>
    <worker-word :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg" @onWorkerWord="handleWord"></worker-word>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>
<script>

  import timeUtils from "../../../../utils/timeUtils";
  import AfterClassService from "../../../my-store/component/AfterClassService";
  import messageUtils from "../../../../utils/messageUtils";
  import globaldata from "../../../../utils/globaldata";
  import commonUtils from "../../../../utils/commonUtils";
  import {workerService} from "../../../../api/AfterClassService";
  import WorkerWord from "../../../../components/WorkerWord/WorkerWord";
  import VisitPics from "../../../components/VisitPics";
  import {getClassServiceAllItem} from "../../../../api/StoreSetting";

  export default {
    name: 'AfterClassServiceBs',
    components: {VisitPics, WorkerWord, AfterClassService},
    props: {
      dataList : Array,
      allWorker:{
        type: Array,
        default: () => ([])
      },
    },
    watch: {
      allWorker: {
        handler (newData) {
          this.allWorkerArray = newData;
        },
        immediate: true,
        deep: true
      }
    },
    data() {
      return {
        selectRow:null,
        tableData:[],
        visibleAfterClassService:false,     //课后服务
        visibleVisitPic:false,     //图片预览
        visitPicList:[],
        refreVisitPic:"",

        allWorkerArray: [],
        //课后服务参数
        afterClassServiceDetail:{},
        afterClassServiceDetailrefresh:"",
        serviceItems:[],

        refreshWord:"",
        showWordDlg:false,
        tData:null,
        wordType : 0,

      }
    },
    mounted() {

    },
    created(){
      this.init();
      this.onGetServiceAllItemOptions();
    },
    methods: {
      rowClick(row, column, event){
        this.selectRow = row;
      },
      init(){
        this.tableData = this.dataList;

        for (let i = 0;i< this.tableData.length;++i){
          let td =  this.tableData[i];
          if (commonUtils.isObjectNull(td)){
            continue;
          }

          td.finish = "未完成";

          if (commonUtils.isObjectNull(td.serviceTeacher) == false && td.serviceTeacher >0){
            let serviceTeacherName = commonUtils.getObjectBuyId(this.allWorkerArray,td.serviceTeacher).name;
            td.serviceTeacherName = serviceTeacherName;
            td.finish = "完成";
          }
          if (commonUtils.isObjectNull(td.photo) == false){
            td.picUrls = JSON.parse(td.photo)
            td.hasPic = true;
          }else {
            td.picUrls =[]
            td.hasPic = false;
          }

          let content = "";
          if (false ==commonUtils.isStringNull(td.classEvaluation)){

            content =  JSON.parse(td.classEvaluation).SW_INTERACTIVE_CONTENT;

            if (!commonUtils.isObjectNull(content)){
              let i =0;
              let sc = "";
              for (;i< content.length-1;++i){
                sc = sc+content[i] +","
              }
              sc = sc +content[i];
              content = sc;
              console.log("td.classEvaluation",sc);
            }



          }

          td.content = content;



          td.classDay = timeUtils.transDay(td.dayTime);
          td.classTime = timeUtils.transTimeHM(td.classStartTime) + "~" +timeUtils.transTimeHM(td.classEndTime)

        }

      },
      handleAfterClassShowDlg(){
        if (this.selectRow == null){
          messageUtils.errorMsg(this,"请选择一条数据");
          return;
        }
        this.visibleAfterClassService = true;
      },
      onBtnOKSerivce(param){
        this.doRefreshWord(true,1,param);
      },

      doRefreshWord(show,wordType,tData){
        this.wordType = wordType;
        this.tData = tData;
        this.refreshWord = new Date().getTime();
        this.showWordDlg = show;
      },
      closeWordDlg(){
        this.wordType = 0;
        this.refreshWord = new Date().getTime();
        this.showWordDlg = false;
      },

      doWorkerService(param){
        workerService(param).then(response =>
        {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          messageUtils.successMsg(this,response.message)
          this.closeWordDlg();
          this.visibleAfterClassService = false;
          this.$emit('onServiceOk');
        })
      },

      handleWord(wordType,tData){

        if (wordType == 1){
          this.doWorkerService(tData)
        }
      },

      onVisitPics(pics){

        this.visitPicList = pics;
        this.visibleVisitPic = true;
        this.refreVisitPic = new Date().getTime();
      },


      /**
       * 获取所有服务的选项
       */
      onGetServiceAllItemOptions(){
        let param = {
          id:globaldata.getAdminStore().storeFrontId
        }
        getClassServiceAllItem(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.serviceItems = data;


          this.afterClassServiceDetailrefresh = new  Date().getTime();
        })

      },


    }
  }
</script>






// WEBPACK FOOTER //
// src/views/service/after-class-service/components/AfterClassServiceBs.vue